import React, { Fragment } from "react";
import { useSubRoutes, SUBROUTES_MAP, ROUTES } from "Navigation";

export const AddEditMain: React.FC = () => {
  const mapSubRoutes = useSubRoutes();

  return <Fragment>{mapSubRoutes(SUBROUTES_MAP[ROUTES.ADD_EDIT])}</Fragment>;
};
